import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import ShopDetailsArea from './ShopDetailsArea';
import ShopArea from './ShopArea';

const ShopDetailsMain = () => {
  return (
    <main>
      <Breadcrumb title="Shop Details" subTitle="Shop" />
      <ShopDetailsArea />
      <ShopArea />
    </main>
  );
};

export default ShopDetailsMain;
